export const ABOUT_US = 'Про нас';
export const PROGRAMS = 'Програми';
export const REPORTING = 'Звітність';
export const HOW_TO_SUPPORT = 'Як підтримати?';

export const CONTACT_US = "Зв' язатись";
export const DONATE = 'Донатити';
